// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_sKQ","cls2":"NewsInteractionBar-cls2_Z53 NewsInteractionBar-cls1_sKQ"};